import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, renderList as _renderList, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1ef25eec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "prediction-batch" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "BMS推定", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "lead" }, " 個体ごとの ZIP をまとめて選択すると、個体情報と飼養管理者候補を自動で取得します。 内容を確認してから一括で推定してください。 ", -1))
const _hoisted_4 = { class: "el-upload__text" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", null, "クリックして選択", -1))
const _hoisted_6 = {
  key: 0,
  class: "actions"
}
const _hoisted_7 = { class: "actions__summary" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "thickness-hint" }, " 4項目すべて入力した行のみ、推定後に類似画像検索の結果を保存します。 ", -1))
const _hoisted_9 = { class: "cattle-id-editor" }
const _hoisted_10 = {
  key: 0,
  class: "sub-text"
}
const _hoisted_11 = {
  key: 0,
  class: "sub-text"
}
const _hoisted_12 = {
  key: 0,
  class: "error-text"
}
const _hoisted_13 = { class: "bms-value" }
const _hoisted_14 = {
  key: 0,
  class: "sub-text"
}
const _hoisted_15 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_card, { shadow: "never" }, {
      default: _withCtx(() => [
        _hoisted_2,
        _hoisted_3,
        _createVNode(_component_el_upload, {
          ref: "uploadRef",
          drag: "",
          "auto-upload": false,
          multiple: true,
          limit: _ctx.maxFiles,
          "on-change": _ctx.handleFileChange,
          "on-remove": _ctx.handleFileRemove,
          "on-exceed": _ctx.handleExceed,
          disabled: _ctx.isPredicting
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createTextVNode(" ZIP をドロップするか、"),
              _hoisted_5,
              _createTextVNode("（最大" + _toDisplayString(_ctx.maxFiles) + "件） ", 1)
            ])
          ]),
          _: 1
        }, 8, ["limit", "on-change", "on-remove", "on-exceed", "disabled"]),
        (_ctx.rows.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(_component_el_button, {
                type: "primary",
                loading: _ctx.isPredicting,
                disabled: !_ctx.canPredictAll,
                onClick: _ctx.predictAll
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 一括推定（" + _toDisplayString(_ctx.pendingCount) + "件） ", 1)
                ]),
                _: 1
              }, 8, ["loading", "disabled", "onClick"]),
              _createElementVNode("span", _hoisted_7, [
                (_ctx.isInspecting)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode("個体情報を取得中…")
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode("完了 " + _toDisplayString(_ctx.succeededCount) + " / 失敗 " + _toDisplayString(_ctx.failedCount), 1)
                    ], 64))
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (_ctx.rows.length)
      ? (_openBlock(), _createBlock(_component_el_table, {
          key: 0,
          data: _ctx.rows,
          class: "rows",
          "row-key": "uid",
          border: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, { type: "expand" }, {
              default: _withCtx(({ row }) => [
                _createVNode(_component_el_form, {
                  "label-width": "180px",
                  class: "thickness-form",
                  onSubmit: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"]))
                }, {
                  default: _withCtx(() => [
                    _hoisted_8,
                    _createVNode(_component_el_form_item, { label: "僧帽筋厚さ (cm)" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: row.trapeziusThickness,
                          "onUpdate:modelValue": ($event: any) => ((row.trapeziusThickness) = $event),
                          type: "number",
                          min: "0"
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_el_form_item, { label: "僧帽筋上皮下脂肪厚さ (cm)" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: row.trapeziusSubcutaneousFatThickness,
                          "onUpdate:modelValue": ($event: any) => ((row.trapeziusSubcutaneousFatThickness) = $event),
                          type: "number",
                          min: "0"
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_el_form_item, { label: "皮下脂肪厚さ (cm)" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: row.subcutaneousFatThickness,
                          "onUpdate:modelValue": ($event: any) => ((row.subcutaneousFatThickness) = $event),
                          type: "number",
                          min: "0"
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_el_form_item, { label: "広背筋厚さ (cm)" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: row.latissimusThickness,
                          "onUpdate:modelValue": ($event: any) => ((row.latissimusThickness) = $event),
                          type: "number",
                          min: "0"
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "ファイル",
              prop: "name",
              "min-width": "180"
            }),
            _createVNode(_component_el_table_column, {
              label: "個体識別番号",
              "min-width": "220"
            }, {
              default: _withCtx(({ row }) => [
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_el_input, {
                    modelValue: row.cattleId,
                    "onUpdate:modelValue": ($event: any) => ((row.cattleId) = $event),
                    maxlength: "10",
                    placeholder: "10桁",
                    disabled: row.status === 'inspecting'
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"]),
                  _createVNode(_component_el_button, {
                    plain: "",
                    size: "small",
                    loading: row.status === 'inspecting',
                    onClick: ($event: any) => (_ctx.reinspect(row))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" 再取得 ")
                    ]),
                    _: 2
                  }, 1032, ["loading", "onClick"])
                ]),
                (row.cattleIdOverridden)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_10, " ZIP内: " + _toDisplayString(row.originalCattleId), 1))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "NLBC飼養者",
              "min-width": "140"
            }, {
              default: _withCtx(({ row }) => [
                _createTextVNode(_toDisplayString(row.farmer || '未取得'), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "飼養管理者",
              "min-width": "260"
            }, {
              default: _withCtx(({ row }) => [
                _createVNode(_component_el_select, {
                  modelValue: row.breedingManagerId,
                  "onUpdate:modelValue": ($event: any) => ((row.breedingManagerId) = $event),
                  filterable: "",
                  clearable: "",
                  placeholder: "氏名・市町村（部分一致）",
                  style: {"width":"100%"},
                  loading: _ctx.isLoadingManagers
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.managerOptions(row), (manager) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: manager.id,
                        label: _ctx.formatManagerLabel(manager),
                        value: manager.id
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 2
                }, 1032, ["modelValue", "onUpdate:modelValue", "loading"]),
                (row.autoSelected)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_11, "候補から自動選択"))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "状態",
              "min-width": "160"
            }, {
              default: _withCtx(({ row }) => [
                _createVNode(_component_el_tag, {
                  type: _ctx.statusTagType(row.status),
                  "disable-transitions": ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.statusLabel(row.status)), 1)
                  ]),
                  _: 2
                }, 1032, ["type"]),
                (row.error)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(row.error), 1))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "BMS",
              "min-width": "120"
            }, {
              default: _withCtx(({ row }) => [
                (row.bms != null)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("strong", _hoisted_13, _toDisplayString(row.bms), 1),
                      (row.rank5Percentage != null)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_14, " 5等級 " + _toDisplayString(row.rank5Percentage) + " % ", 1))
                        : _createCommentVNode("", true),
                      _createVNode(_component_el_button, {
                        link: "",
                        type: "primary",
                        onClick: ($event: any) => (_ctx.openDetail(row))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" 結果を別ウィンドウで開く ")
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ], 64))
                  : (_openBlock(), _createElementBlock("span", _hoisted_15, "-"))
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"]))
      : _createCommentVNode("", true)
  ]))
}